module.exports = __webpack_public_path__ + "img/clinical-report.aba3155b.png";